export const CourseDetailsCard = [
  {
    id: 1,
    u_id: "66deae21e0d8c652cf567c0",
    name: "JavaScript Basics",
    Enrolled: 1200,
    reviews: 200,
    points: 150,
    hours: 40,
    price: 49.99,
    Chapters: 7,
    Lessons: [
      {
        chapter: "Introduction to JavaScript",
        content: [
          {
            id: "js-intro-1",
            title: "What is JavaScript?",
            video_url:
              "https://www.youtube.com/embed/lfmg-EJ8gm4?si=AZoWVaCqLwCz0gLB",
          },
          {
            id: "js-intro-2",
            title: "Setting up Development Environment",
            video_url: "https://www.youtube.com/embed/RgOEKdA2mlw",
          },
        ],
      },
      {
        chapter: "JavaScript Variables",
        content: [
          {
            id: "js-var-1",
            title: "Declaring Variables",
            video_url: "https://www.youtube.com/embed/A3mc4Ql5OBE",
          },
          {
            id: "js-var-2",
            title: "Types of Variables",
            video_url: "https://www.youtube.com/embed/kbvHM2S2_bk",
          },
        ],
      },
    ],
    image:
      "https://cdn.sanity.io/images/3do82whm/next/a69e3ba2441d35dd1a7945e826064708f30c10a9-1000x667.jpg?w=720&h=480&fit=clip&auto=format",
    promo_url: "https://www.youtube.com/watch?v=UwYW9vuJ1Ho",
  },
  {
    id: 2,
    u_id: "66deae21e0d8c6552cf567d0",
    name: "React Fundamentals",
    Enrolled: 950,
    reviews: 180,
    points: 180,
    hours: 30,
    price: 59.99,
    Chapters: 7,
    image:
      "https://miro.medium.com/v2/resize:fit:1400/1*x0d41ns8PTQZz4a3VbMrBg.png",
  },
  {
    id: 3,
    u_id: "66deae21e0d8c6552cf567d1",
    name: "Advanced CSS",
    Enrolled: 750,
    reviews: 150,
    points: 170,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://kinsta.com/wp-content/uploads/2024/01/wp-advanced-css-techniques.jpg",
  },
  {
    id: 4,
    u_id: "66deae21e0d8c6552cf567d2",
    name: "Python for Data Science",
    Enrolled: 1600,
    reviews: 250,
    points: 200,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://cdn.shopaccino.com/igmguru/products/data-science--with-python-igmguru_176161162_l.jpg?v=444",
  },
  {
    id: 5,
    u_id: "66deae21e0d8c6552cf567d3",
    name: "Machine Learning",
    Enrolled: 1100,
    reviews: 220,
    points: 190,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://datascientest.com/en/files/2021/01/Machine-learning-def-.png",
  },
  {
    id: 6,
    u_id: "66deae21e0d8c6552cf567d4",
    name: "Node.js Mastery",
    Enrolled: 800,
    reviews: 160,
    points: 175,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://repository-images.githubusercontent.com/589013342/62af123c-b359-411a-b727-6c334a7e6dd4",
  },
  {
    id: 7,
    u_id: "66deae21e0d8c6552cf567d5",
    name: "Full-Stack Development",
    Enrolled: 1300,
    reviews: 210,
    points: 200,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://codingbytes.com/wp-content/uploads/2022/03/full-stack-web-development.jpg",
  },
  {
    id: 8,
    u_id: "66deae21e0d8c6552cf567d6",
    name: "Database Design",
    Enrolled: 900,
    reviews: 170,
    points: 160,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://bs-uploads.toptal.io/blackfish-uploads/components/open_graph_image/8959179/og_image/optimized/0712-Bad_Practices_in_Database_Design_-_Are_You_Making_These_Mistakes_Dan_Social-754bc73011e057dc76e55a44a954e0c3.png",
  },
  {
    id: 9,
    u_id: "66deae21e0d8c6552cf567d7",
    name: "Deep Learning",
    Enrolled: 900,
    reviews: 170,
    points: 160,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image: "https://miro.medium.com/v2/resize:fit:1024/0*3Fh9G_yItopD0r7f.png",
  },
  {
    id: 10,
    u_id: "66deae21e0d8c6552cf567d8",
    name: "HTML",
    Enrolled: 900,
    reviews: 170,
    points: 160,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20220630132824/HTML-Full-Form.jpg",
  },
  {
    id: 11,
    u_id: "66deae21e0d8c6552cf567d9",
    name: "C#",
    Enrolled: 900,
    reviews: 170,
    points: 160,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image: "https://assets.codeguru.com/uploads/2021/08/C-Sharp-Tutorials.png",
  },
  {
    id: 12,
    u_id: "66deae21e0d8c6552cf567da",
    name: "Java",
    Enrolled: 900,
    reviews: 170,
    points: 160,
    hours: 40,
    price: 49.99,
    Chapters: 3,
    image:
      "https://crowdforthink.com/assets/uploads/blogs/582d8348873b7e0fdfaa78320dd3b918.jpg",
  },
];
